import * as React from "react";
import { onlyUpdateForKeys } from "recompose";

import { Card, Text } from "../../../../components/atoms";
import { theme } from "../../../../theme";

interface IProps {
  active?: boolean;
  available?: boolean;
  className?: string;
  day?: string; // formatted day
  fullDate?: string; // full ISO date
  onSelect(date: string): void;
  time?: string; // formatted time
  type: "date" | "time";
  weekday?: string; // formatted weekday
}

const StyledDateCard = Card.extend`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 86px;
  height: 52px;
  border: 1px solid transparent;
  box-shadow: none;
  cursor: pointer;
  transition: border ${theme.transition.linear03};

  &.active {
    border: 2px solid ${theme.color.ruubyRose};
  }

  &:hover:not(.active):not(.disabled) {
    border: 1px solid ${theme.color.ruubyRose};
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media screen and (max-width: 992px) {
    width: 56px;
  }
`;

const StyledTimeCard = StyledDateCard.extend`
  flex-direction: row;
  width: 74px;
  background-color: ${theme.color.borderColorGrey};

  @media screen and (max-width: 992px) {
    width: 70px;
    height: 36px;
  }
`;

const DateCard: React.FC<IProps> = (props) => {
  const { fullDate } = props;

  if (!fullDate) {
    return null;
  }

  return (
    <StyledDateCard
      className={`${props.active && "active"} ${
        !props.available && "disabled"
      } date-card`}
      onClick={() => props.onSelect(fullDate)}
    >
      <Text size="8" weight="bold" color="greyer">
        {props.weekday}
      </Text>
      <Text size="24" weight="semibold">
        {props.day}
      </Text>
    </StyledDateCard>
  );
};

const TimeCard: React.FC<IProps> = (props) => {
  const { time } = props;

  if (!time) {
    return null;
  }

  return (
    <StyledTimeCard
      className={`${props.active && "active"} time-card`}
      onClick={() => props.onSelect(time)}
    >
      <Text weight="bold">{props.time}</Text>
    </StyledTimeCard>
  );
};

const DateTimeCard: React.FC<IProps> = (props) => {
  if (props.type === "date") {
    return <DateCard {...props} />;
  } else if (props.type === "time") {
    return <TimeCard {...props} />;
  } else {
    return null;
  }
};

const pureComponent = onlyUpdateForKeys(["active", "isAvailable"])(
  DateTimeCard,
);

export { pureComponent as DateTimeCard };
